import styles_Searchbar from '../components/Searchbar.module.scss';
import { Fragment, ReactElement, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope as faEnvelopeSolid, faCircleInfo, faAddressBook, faLocationDot, faBagShopping as faBagShoppingSolid, faStore/*, faGear*/, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faBookmark } from '@fortawesome/pro-regular-svg-icons'
import { faUpToLine, faBagsShopping, faBuilding, faBox, faShelves, faGem, faHandHoldingBox, faFilePen, faCloud, faCloudXmark, faTrashXmark, faSignature, faUserTieHairLong, faFileLines, faScaleBalanced, faObjectGroup, faUserMagnifyingGlass, faRecycle } from '@fortawesome/pro-solid-svg-icons'
import { faBagShopping, faBadgeCheck, faEnvelope, faPenToSquare, faFilePdf, faClone, faCloudArrowUp, faEye, faTrashCan, faArrowRight, faLock, faLockOpen, faFileImport, faGem as faGemLight, faBox as faBoxLight, faSheetPlastic as faSheetPlasticLight, faScaleBalanced as faScaleBalancedLight, faObjectGroup as faObjectGroupLight, faCoins } from '@fortawesome/pro-light-svg-icons'
import { faCloudSlash } from '@fortawesome/pro-solid-svg-icons'
// import { faEnvelope, faBagShopping, faBadgeCheck } from '@fortawesome/pro-light-svg-icons'
import DropdownMenu from '../components/DropdownMenu'
import Menu from '../components/Menu/Menu'
import Searchbar from '../components/Searchbar'
import usePrefStore from '../stores/prefs'
import styles from './CustomerDetail.module.scss'
// import useHelpers from '../Hooks/useHelpers'
import useSales from '../Hooks/useSales'
import { useCatalogScopeFlags } from '../Hooks/useIsRetailOnly'
import useCanSeeJewelry from '../Hooks/useCanSeeJewelry'
import PagesButtons from '../components/PagesButtons'
// import GraphPie from '../components/Graph/GraphPie'
import useTranslation from '../Hooks/useTranslation'
import DropdownField from '../components/DropdownField'
import Button from '../components/Button'
import parsePhoneNumber from 'libphonenumber-js'
// import useStateWithHistory from '../Hooks/useStateWithHistory'
import { useSearchParams } from 'react-router-dom'
// import GraphLine from '../components/Graph/GraphLine'
import { useNavigate } from 'react-router-dom';
import useHelpers from '../Hooks/useHelpers'
import { useLiveQuery } from "dexie-react-hooks"
import { Checkbox, States as CheckboxStates } from '../components/Checkbox'
import Confirm from '../components/Confirm'
import { ToastContainer, toast } from 'react-toastify'
import Stats from '../components/Stats'
import MailAddressPicker from '../components/MailAddressPicker';
import QuotaMarkEditor from '../components/QuotaMarkEditor'
import { GlobalContext } from '../Contexts/GlobalContext';
import { AppWriteContext } from '../Contexts/AppWriteContext'
import glob_const from '../libs/glob_const'
import moment from 'moment'
import useRetailQuota from '../Hooks/useRetailQuota'
import useRetailCollections from '../Hooks/useRetailCollections'
import useFinalValidation from '../Hooks/useFinalValidation'
import useReturnToClient from '../Hooks/useReturnToClient'
import useSubmitOrder from '../Hooks/useSubmitOrder'
import useRetailRoleForCustomer from '../Hooks/useRetailRoleForCustomer'
import useIsSingleCustomerLocal from '../Hooks/useIsSingleCustomerLocal'
import { importKOTFile, validateKOTLines } from '../libs/kotExportImport'
import type { Customer, Contact, Order, KTMClientType } from '../types'

const global_menu_items = {
   doSync: "sync",
   doSubmit: "submit",
}

const menu_items = {
   setActive: "active",
   doEdit: "edit",
   doSee: "see",
   doClone: "clone",
   doCloneToDefaultCustomer: "duplicate_to_defcust",
   doSync: "sync",
   doDelete: "delete",
   sendPdf: "pdf",
   writeMail: "writemail",
   createOrder: "neworder",
   doValidateN2: "validate_n2",
   doValidateN1: "validate_n1",
   doUnlock: "unlock",
   doSendToClient: "send_to_client",
   // showAddresses: "showaddr",
   // showContacts: "showcont",
}

const create_menu_items = {
   template: 'create_template',
   order: 'create_order',
   retail: 'create_retail',
   kot: 'create_kot',
   importKot: 'import_kot',
   ktmRet: 'create_ktm_ret',
   ktmEre: 'create_ktm_ere',
   ktmInterco: 'create_ktm_interco',
}

const tab_names = {
   info: "info",
   // stats: "stats",
   contacts: "contacts",
   addresses: "addresses",
   sync: "sync",
   orders: "orders",
   unsync: "unsync",
   quotas: "quotas"
}

const search_type = {
   other_client: "other_client",
   order: "order",
   sku: "sku",
}

function CustomerDetail() {
   const listPageLength = Number(usePrefStore((state) => state.listPageLength))
   const { setListPageLength, curCustomer, setCurCustomer, curOrder, setCurOrder, formatPhone, currentLang, searchModeInCustomer, setSearchModeInCustomer, retailRole } = usePrefStore();
   const { setIsDarkLayerVisible } = { ...GlobalContext() } as any
   // States mémo pour historique
   // const [curFilter, setCurFilter] = useStateWithHistory('cust_cur_filter', null)   // null === Tous
   // const [curPage, setCurPage] = useStateWithHistory('cust_cur_page', 1)
   // const [searchText, setSearchText] = useStateWithHistory('cust_search_text', '')
   // States
   // const [isSearchFilterVisible, setIsSearchFilterVisible] = useState(false)
   const [searchText, setSearchText] = useState('')
   const [customer, setCustomer] = useState<Customer | null>(null)
   // Rôle vis-à-vis de CE customer (la page est dédiée à un seul client) :
   // utilisé pour les filtres de listes, le menu déroulant order, et la
   // visibilité de l'onglet "À valider".
   const roleForCustomer = useRetailRoleForCustomer(customer?.id)
   // Mode "1 seul client local" : on cache le bouton "Quitter le client"
   // (le user ne peut pas se retrouver sans client sélectionné).
   const isSingleCustomer = useIsSingleCustomerLocal()
   const [selectedContact, setSelectedContact] = useState<Contact | null>(null)
   const [searchBar, setSearchBar] = useState<ReactElement | null>(null)
   const [contactsLines, setContactsLines] = useState<ReactElement[] | null>(null)
   const [addressesLines, setAddressesLines] = useState<ReactElement[] | null>(null)
   const [linesSyncOrders, setLinesSyncOrders] = useState<ReactElement[] | null>(null) // Commandes sync affichées sur la page courante
   const [linesUnsyncOrders, setLinesUnsyncOrders] = useState<ReactElement[] | null>(null) // Commande unsync affichés sur la page courante
   const [filteredSyncOrders, setFilteredSyncOrders] = useState<Order[] | null>(null) // Commandes sync de la page courante
   const [filteredUnsyncOrders, setFilteredUnsyncOrders] = useState<Order[] | null>(null) // Commandes unsync de la page courante
   const [linesQuotaOrders, setLinesQuotaOrders] = useState<ReactElement[] | null>(null)
   const [filteredQuotaOrders, setFilteredQuotaOrders] = useState<Order[] | null>(null)
   const [unsyncLinesChecked, setUnsyncLinesChecked] = useState<Set<string>>(new Set())
   const [unsyncLinesAllChecked, setUnsyncLinesAllChecked] = useState(false)
   const [unsyncLinesNoneChecked, setUnsyncLinesNoneChecked] = useState(false)
   const [curPageSyncOrders, setCurPageSyncOrders] = useState(1) // N° de la page courante des commandes sync
   const [curPageUnsyncOrders, setCurPageUnsyncOrders] = useState(1) // N° de la page courante des commandes unsync
   const [curPageQuotaOrders, setCurPageQuotaOrders] = useState(1)
   const [nbPagesSyncOrders, setNbPagesSyncOrders] = useState(1)
   const [nbPagesUnsyncOrders, setNbPagesUnsyncOrders] = useState(1)
   const [nbPagesQuotaOrders, setNbPagesQuotaOrders] = useState(1)
   const [firstPageSyncOrders, setFirstPageSyncOrders] = useState(1) // 1ère page des commandes sync sur le composant de pages
   const [firstPageUnsyncOrders, setFirstPageUnsyncOrders] = useState(1)   // 1ère page des commandes unsync sur le composant de pages
   const [firstPageQuotaOrders, setFirstPageQuotaOrders] = useState(1)
   const [dropdownMenuContact, setDropdownMenuContact] = useState<ReactElement | null>(null)
   const [pagesButtonsSyncOrders, setPagesButtonsSyncOrders] = useState<ReactElement | null>(null)
   const [pagesButtonsUnsyncOrders, setPagesButtonsUnsyncOrders] = useState<ReactElement | null>(null)
   const [pagesButtonsQuotaOrders, setPagesButtonsQuotaOrders] = useState<ReactElement | null>(null)
   const [dropdownMenuAddress, setDropdownMenuAddress] = useState<ReactElement | null>(null)
   const [showDropdownMenuOnContactNum, setShowDropdownMenuOnContactNum] = useState<number | null>(null)
   const [showDropdownMenuOnAddressNum, setShowDropdownMenuOnAddressNum] = useState<number | null>(null)
   const [showDropdownMenuGlobal, setShowDropdownMenuGlobal] = useState(false);
   const [dropdownMenuGlobal, setDropdownMenuGlobal] = useState<ReactElement | null>(null);
   const [isItemsPerPageOpen, setIsItemsPerPageOpen] = useState(false)
   const [curTab, setCurTab] = useState<string | undefined>()
   const [dropdownMenuOrders, setDropdownMenuOrders] = useState<ReactElement | null>(null)
   const [showDropdownMenuOnOrderId, setShowDropdownMenuOnOrderId] = useState<string | null>(null)
   const [lastPickedOrderId, setLastPickedOrderId] = useState<string | null>(null)  // Pour envoi PDF
   const [selectedOrder, setSelectedOrder] = useState<Order | null>(null)
   const [isConfirmVisible, setIsConfirmVisible] = useState(false)
   const [isMailAddressPickerVisible, setIsMailAddressPickerVisible] = useState(false)
   const [deleteOrderId, setDeleteOrderId] = useState<string | null>(null)
   const [isConfirmSyncVisible, setIsConfirmSyncVisible] = useState(false)
   const [isConfirmSubmitVisible, setIsConfirmSubmitVisible] = useState(false)
   const [stats, setStats] = useState<ReactElement | null>(null)
   const [showQuotaCloneEditor, setShowQuotaCloneEditor] = useState(false)
   const [quotaCloneSourceOrder, setQuotaCloneSourceOrder] = useState<Order | null>(null)
   const [showCreateMenu, setShowCreateMenu] = useState(false);
   const [showKtmCreateEditor, setShowKtmCreateEditor] = useState(false)
   const [ktmCreateInitialMark, setKtmCreateInitialMark] = useState<string | null>(null)
   const kotImportFileRef = useRef<HTMLInputElement>(null)
   //
   const { getCustomerById, setCustomerIdAsCurrent, getContactsFromCustomerAsSortedArray, getAddressesFromCustomerAsSortedArray, type_address, tag_address, createOrder, makeTemplateOrder, getUnsyncOrdersForCustomerId, getSyncOrdersForCustomerId, getUnsyncOrdersAsArray, order_status, type_order, calcTotalForOrder, getOrderById, setOrderIdAsCurrent, updateRecentOrders, updateOrder, cloneOrder, deleteOrder, canSyncOrder, isOrderComplete, canWriteKOT, isRetailOrder, countCheckedRetail, isKOTOrder, isKTMOrder, canCreateRetailOrder, getRetailOrderType, submitRetailOrder, validateRetailN2, validateRetailN1, returnRetailToClient, sendRetailToClient, computeRefusedLines, isOrderSubmittedOrLocked } = useSales()
   const { canCreateKOT, canCreateKTM, generateKOTMark, generateKTMMark, extractClientTypeFromKTMMark, KTM_CLIENT_TYPES } = useRetailQuota()
   const { getRetailModelById } = useRetailCollections()
   const { isRetailOnly, hasBoth } = useCatalogScopeFlags()
   const canSeeJewelry = useCanSeeJewelry()   // false = retail-only : pas de création bijoux ni d'onglet Informations
   const { requestFinalValidation, finalValidationPopups } = useFinalValidation({ validateRetailN1, computeRefusedLines, isRetailOrder, getRetailModelById })
   const { requestReturnToClient, returnToClientPopups } = useReturnToClient({ sendRetailToClient, returnRetailToClient, newMgrStatus: order_status.new_mgr })
   const { requestSubmit, submitPopups } = useSubmitOrder({ submitRetailOrder, updateOrder, isRetailOrder, lockedForSyncStatus: order_status.locked4sync })
   const { trans, lowtrans } = useTranslation()
   // Pictos de synchro — cas particulier du USER-CLIENT retail : on ne lui expose pas le détail
   // du workflow interne de validation (il n'a pas à savoir si sa commande est chez le N1 ou le N2).
   //   - wait_n1 / wait_n2  → loupe-user À LA PLACE du nuage, rien en dessous ("en cours d'examen")
   //   - locked / wait_m3   → nuage seul, sans le "M3" en dessous
   // Les autres rôles (admin / N1 / N2 / commercial) gardent l'affichage complet N1/N2/M3.
   const hideRetailWorkflow = useCallback((an_order: Order) => retailRole === 'client' && isRetailOrder(an_order), [retailRole, isRetailOrder])
   const isUnderRetailReview = useCallback((an_order: Order) => hideRetailWorkflow(an_order) && (an_order.status === order_status.wait_n1 || an_order.status === order_status.wait_n2), [hideRetailWorkflow, order_status])
   //
   const [searchParams] = useSearchParams()
   const { buildAddress, formatCESPrice } = useHelpers()
   const navigate = useNavigate()
   const { awPushPDF, addFakeLocalCustomer } = { ...AppWriteContext() } as any
   //
   const live_sync_orders = useLiveQuery(async () => (await getSyncOrdersForCustomerId(customer?.id))?.filter(an_order => {
      if (an_order.type === type_order.confie_facture) return false
      // Document KOT visible seulement pour admin / N1 de ce customer. Le N2 (comme le user-client)
      // a le KOT en local pour le picker, mais pas accès au document.
      if (!(roleForCustomer.isAdmin || roleForCustomer.isN1) && an_order.type === type_order.retail_quota) return false
      return true
   }), [customer, roleForCustomer, type_order])
   const live_unsync_orders = useLiveQuery(async () => (await getUnsyncOrdersForCustomerId(customer?.id))?.filter(an_order => {
      if (!(roleForCustomer.isAdmin || roleForCustomer.isN1) && an_order.type === type_order.retail_quota) return false
      return true
   }), [customer, roleForCustomer, type_order])

   // Marks existantes pour la duplication d'un quota / modèle quota
   const existingQuotaCloneMarks = useMemo(() => {
      if (!quotaCloneSourceOrder) return []
      if (isKOTOrder(quotaCloneSourceOrder)) {
         // KOT : marks des KOT du même client (en excluant la source)
         return (live_unsync_orders ?? [])
            .filter(o => o.type === type_order.retail_quota
               && o.mark
               && o.customer_id === quotaCloneSourceOrder.customer_id
               && o.id !== quotaCloneSourceOrder.id)
            .map(o => o.mark!)
      }
      // KTM : marks de tous les KTM (en excluant la source)
      return (live_unsync_orders ?? [])
         .filter(o => o.type === type_order.ktm_quota && o.mark && o.id !== quotaCloneSourceOrder.id)
         .map(o => o.mark!)
   }, [live_unsync_orders, type_order.retail_quota, type_order.ktm_quota, quotaCloneSourceOrder, isKOTOrder])

   const [filterCDE, setFilterCDE] = useState(false)
   const [filterCDI, setFilterCDI] = useState(false)
   const [filterCON, setFilterCON] = useState(false)
   const [filterTRI, setFilterTRI] = useState(false)
   const [filterOME, setFilterOME] = useState(false)
   const [filterDEV, setFilterDEV] = useState(false)
   const [filterRET, setFilterRET] = useState(false)   // filtre ECR+ECF (mode mixte retail+bijoux)
   const [isProspect, setIsProspect] = useState(false)

   // Réinitialise les filtres devenus non pertinents selon le périmètre catalogue,
   // pour qu'un filtre masqué resté actif ne fausse pas le filtrage inclusif plus bas.
   //  - retail-only : les filtres de type bijoux (CDE/CDI/CON/DEV/oMe) sont masqués.
   //  - hors mode mixte : le filtre ECR/F (ECR+ECF) n'a pas de sens.
   useEffect(() => {
      if (isRetailOnly) {
         setFilterCDE(false)
         setFilterCDI(false)
         setFilterCON(false)
         setFilterTRI(false)
         setFilterDEV(false)
         setFilterOME(false)
      }
      if (!hasBoth) setFilterRET(false)
   }, [isRetailOnly, hasBoth])
   const [default_customer, setDefaultCustomer] = useState<Customer | undefined>();

   useEffect(() => {
      setStats(<Stats customer={customer?.id} />)
   }, [customer])

   useEffect(() => {
      setIsDarkLayerVisible(isMailAddressPickerVisible)
   }, [isMailAddressPickerVisible, setIsDarkLayerVisible])

   useEffect(() => {
      if (curCustomer) {
         setDefaultCustomer(getCustomerById(curCustomer))
      } else {
         setDefaultCustomer(null)
      }
   }, [curCustomer, getCustomerById])

   useEffect(() => {
      let tab = searchParams.get('tab')
      // if (tab === 'info') {   // TODO Supprimer quand on aura les infos des 2 prems tabs
      //    tab = 'contacts'
      // }
      const id = searchParams.get('id')

      // Retail-only (pas d'accès bijoux) : l'onglet "Informations" est masqué → onglet par
      // défaut = "En cours oMe" (unsync), et on ne laisse pas non plus atterrir sur 'info'.
      let resolvedTab = tab ?? (canSeeJewelry ? tab_names.info : tab_names.unsync)
      if (!canSeeJewelry && resolvedTab === tab_names.info) resolvedTab = tab_names.unsync
      setCurTab(resolvedTab)

      const cust = getCustomerById(id)
      setCustomer(cust)
      setIsProspect(cust?.id && cust.id.startsWith(glob_const.prefix_prospect))
   }, [getCustomerById, searchParams, canSeeJewelry])

   // console.log('+++Customer', customer)

   const onSearch = useCallback((text) => {
      if (((curTab !== tab_names.sync) && (curTab !== tab_names.unsync) && (curTab !== tab_names.quotas)) || (searchModeInCustomer === search_type.other_client)) {
         navigate(`/customers?search=${encodeURIComponent(text)}`, { replace: true })
      }
   }, [curTab, navigate, searchModeInCustomer])

   const onSelectAddress = useCallback((id) => {
      if (id === menu_items.setActive) {
         setCustomerIdAsCurrent(customer.id)
         setShowDropdownMenuOnAddressNum(null)
      }
   }, [customer, setCustomerIdAsCurrent])

   const onSelectContact = useCallback((id) => {
      if (id === menu_items.setActive) {
         setCustomerIdAsCurrent(customer.id)
      } else if (id === menu_items.writeMail) {
         window.location.href = `mailto:${selectedContact.email}`
      }
      setShowDropdownMenuOnContactNum(null)
   }, [customer, selectedContact, setCustomerIdAsCurrent])

   const prepShowDropDown = useCallback(async (id) => {
      if (id !== null) {
         setShowDropdownMenuOnOrderId(id)
         setLastPickedOrderId(id)
         setSelectedOrder(await getOrderById(id))
      } else {
         setShowDropdownMenuOnOrderId(null)
         setSelectedOrder(null)
      }
   }, [getOrderById])

   const onSelectMenuOrder = useCallback(async (id) => {
      // console.log('ID>>', id, showDropdownMenuOnCustomerId);
      prepShowDropDown(null)  // On referme en mode async mais pas de pb
      if (id === menu_items.setActive) {
         setOrderIdAsCurrent(showDropdownMenuOnOrderId)
      } else if (id === menu_items.doEdit) {
         // Une commande soumise/verrouillée se consulte mais ne devient pas la commande courante.
         const ord = await getOrderById(showDropdownMenuOnOrderId)
         if (ord && !isOrderSubmittedOrLocked(ord.status)) setCurOrder(showDropdownMenuOnOrderId)
         updateRecentOrders(showDropdownMenuOnOrderId)
         navigate(`/order-detail?id=${showDropdownMenuOnOrderId}`, { replace: false })
      } else if (id === menu_items.doSee) {
         // Consultation seule : on ouvre le détail SANS sélectionner (comme un clic sur la ligne).
         updateRecentOrders(showDropdownMenuOnOrderId)
         navigate(`/order-detail?id=${showDropdownMenuOnOrderId}`, { replace: false })
      } else if (id === menu_items.doClone) {
         const order = await getOrderById(showDropdownMenuOnOrderId)
         if (order && (isKOTOrder(order) || isKTMOrder(order))) {
            // KOT/KTM : ouvrir l'éditeur pour choisir une nouvelle contremarque (unique)
            setQuotaCloneSourceOrder(order)
            setShowQuotaCloneEditor(true)
         } else {
            cloneOrder(showDropdownMenuOnOrderId)
            setCurTab(tab_names.unsync)
         }
      } else if (default_customer && id === menu_items.doCloneToDefaultCustomer) {
         cloneOrder(showDropdownMenuOnOrderId, default_customer.id)
         navigate(`/customer-detail?id=${default_customer?.id}&tab=unsync`, { replace: false })
      } else if (id === menu_items.sendPdf) {
         setIsMailAddressPickerVisible(true)
      } else if (id === menu_items.doDelete) {
         setDeleteOrderId(showDropdownMenuOnOrderId)
         setIsConfirmVisible(true)
      } else if (id === menu_items.doSync) {
         // Flux unique : popup de confirmation puis soumission (retail) / synchronisation (classique).
         const order = await getOrderById(showDropdownMenuOnOrderId)
         requestSubmit(order)
      } else if (id === menu_items.doValidateN2) {
         const order = await getOrderById(showDropdownMenuOnOrderId)
         // N2 valide → webhook validate-n2 (le serveur décide wait_n1 ou locked + perms).
         await validateRetailN2(order)
      } else if (id === menu_items.doValidateN1) {
         const order = await getOrderById(showDropdownMenuOnOrderId)
         requestFinalValidation(order)   // flux unique : confirmation (+ reliquat) puis validateRetailN1
      } else if (id === menu_items.doUnlock || id === menu_items.doSendToClient) {
         // Flux unique « Renvoyer au client » (confirmation + dispatch new_mgr / wait_n*).
         const order = await getOrderById(showDropdownMenuOnOrderId)
         requestReturnToClient(order, () => {
            setCurOrder(null)
            navigate(id === menu_items.doSendToClient ? '/orders?tab=unsync' : '/orders?tab=pending', { replace: true })
         })
      }
   }, [cloneOrder, default_customer, getOrderById, isKOTOrder, isKTMOrder, navigate, prepShowDropDown, setCurOrder, setOrderIdAsCurrent, showDropdownMenuOnOrderId, updateRecentOrders, validateRetailN2, requestReturnToClient, requestFinalValidation, requestSubmit, isOrderSubmittedOrLocked])

   async function onConfirmOK() {
      setIsConfirmVisible(false)
      deleteOrder(deleteOrderId)
      setDeleteOrderId(null)
   }

   function onConfirmCancel() {
      setIsConfirmVisible(false)
      setDeleteOrderId(null)
   }

   useEffect(() => {
      if (customer && (showDropdownMenuOnContactNum !== null)) {
         const contact = getContactsFromCustomerAsSortedArray(customer)[showDropdownMenuOnContactNum]
         setSelectedContact(contact)
      } else {
         setSelectedContact(null)
      }
   }, [customer, getContactsFromCustomerAsSortedArray, showDropdownMenuOnContactNum])

   useEffect(() => {
      if ((curTab === tab_names.sync) || (curTab === tab_names.unsync) || (curTab === tab_names.quotas)) {

         // Filtres de type masqués en retail-only et dans l'onglet KOT (quotas, 100% retail).
         // Le filtre ECR/F (ECR+ECF) n'apparaît qu'en mode mixte (hasBoth).
         const left_toolz = (
            !isRetailOnly && curTab !== tab_names.quotas && <div className={styles_Searchbar.left_tools}>
               <button className={filterCDE ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterCDE(cur => !cur) }}>
                  <FontAwesomeIcon icon={faGem} />
                  <span>CDE</span>
               </button>
               <button className={filterCDI ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterCDI(cur => !cur) }}>
                  <FontAwesomeIcon icon={faShelves} />
                  <span>CDI</span>
               </button>
               <button className={filterCON ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterCON(cur => !cur) }}>
                  <FontAwesomeIcon icon={faHandHoldingBox} />
                  <span>CON</span>
               </button>
               {(curTab === tab_names.sync) &&
                  <button className={filterOME ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterOME(cur => !cur) }}>
                     oMe
                  </button>}
               <button className={filterTRI ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterTRI(cur => !cur) }}>
                  <FontAwesomeIcon icon={faRecycle} />
                  <span>TRI</span>
               </button>
               {(curTab === tab_names.unsync) &&
                  <button className={filterDEV ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterDEV(cur => !cur) }}>
                     <FontAwesomeIcon icon={faFilePen} />
                     <span>DEV</span>
                  </button>}
               {hasBoth &&
                  <button className={filterRET ? styles_Searchbar.state_on : styles_Searchbar.state_off} onClick={() => { setFilterRET(cur => !cur) }}>
                     <FontAwesomeIcon icon={faBox} />
                     <span>ECR</span>
                  </button>}
            </div >
         )
         setSearchBar(
            <Searchbar text={searchText} onSearch={onSearch} placeholder={trans((searchModeInCustomer === search_type.other_client) ? '?Chercher un client (code, nom, ville, pays, clé)' : (searchModeInCustomer === search_type.order) ? '?Chercher une commande' : '?Chercher un SKU')} left_tools={
               left_toolz} onChange={(text) => setSearchText(text)} >
               <div className={styles_Searchbar.search_tools}>
                  <button className={(searchModeInCustomer === search_type.other_client) ? styles_Searchbar.red : ''} onClick={() => { setSearchModeInCustomer(search_type.other_client) }}>
                     <FontAwesomeIcon icon={faUserTieHairLong} />
                  </button>
                  <button className={(searchModeInCustomer === search_type.order) ? styles_Searchbar.red : ''} onClick={() => { setSearchModeInCustomer(search_type.order) }}>
                     <FontAwesomeIcon icon={faFileLines} />
                  </button>
                  <button className={(searchModeInCustomer === search_type.sku) ? styles_Searchbar.red : ''} onClick={() => { setSearchModeInCustomer(search_type.sku) }}>
                     <FontAwesomeIcon icon={(isRetailOnly || curTab === tab_names.quotas) ? faBox : faGem} />
                  </button>
               </div>
            </Searchbar>)
      } else {
         setSearchBar(<Searchbar onSearch={onSearch} />)
      }
   }, [curTab, filterCDE, filterCDI, filterCON, filterTRI, filterDEV, filterOME, filterRET, hasBoth, isRetailOnly, onSearch, searchModeInCustomer, searchText, setSearchModeInCustomer, trans])

   useEffect(() => {
      setDropdownMenuContact(
         <DropdownMenu noscrollbars right={-20} top={20} onSelect={onSelectContact}>
            <li disabled={(selectedContact?.email === null) || (selectedContact?.email.indexOf('@') === -1)} id={menu_items.writeMail}>
               <FontAwesomeIcon icon={faEnvelope} />
               {trans('?Ecrire un mail')}
            </li>
            <li disabled={/*(selectedContact?.phone1 === null) && (selectedContact?.phone2 === null)*/true} id={menu_items.writeMail}>
               <FontAwesomeIcon icon={faPhone} />
               {trans('?Appeler')}
            </li>
         </DropdownMenu>
      )
   }, [curCustomer, customer, onSelectContact, selectedContact, trans])

   useEffect(() => {
      // Menu affiché sur une ligne d'adresse du client
      setDropdownMenuAddress(
         <DropdownMenu noscrollbars right={-20} top={20} onSelect={onSelectAddress}>
            <li disabled={curCustomer === customer?.id} id={menu_items.setActive}>
               <FontAwesomeIcon icon={faBadgeCheck} />
               {trans('?Sélectionner')}
            </li>
            <li disabled id={menu_items.createOrder}>
               <FontAwesomeIcon icon={faBagShopping} />
               {trans('?Créer une commande')}
            </li>
         </DropdownMenu>
      )
   }, [curCustomer, customer?.id, onSelectAddress, trans])

   useEffect(() => {
      if (selectedOrder) {
         const val = selectedOrder.readonly
         console.log('SEL ORDER', { ...selectedOrder }, val);
         setDropdownMenuOrders(
            <DropdownMenu noscrollbars right={-20} top={20} onSelect={onSelectMenuOrder}>
               {(() => {
                  const canEditRetail = isRetailOrder(selectedOrder) && (
                     (roleForCustomer.isN2 && selectedOrder?.status === order_status.wait_n2) ||
                     ((roleForCustomer.isN1 || roleForCustomer.isAdmin) && (selectedOrder?.status === order_status.wait_n1 || selectedOrder?.status === order_status.wait_n2))
                  )
                  // KOT : sélection/modif réservées à admin/N1 (canWriteKOT) → sinon « Voir » seul.
                  const editable = (!selectedOrder.readonly || canEditRetail) && canWriteKOT(selectedOrder, roleForCustomer)
                  return editable ? (
                     <>
                        <li id={menu_items.doEdit}>
                           <FontAwesomeIcon icon={faPenToSquare} />
                           {trans('?Modifier')}
                        </li>
                        <li disabled={curOrder === showDropdownMenuOnOrderId} id={menu_items.setActive}>
                           <FontAwesomeIcon icon={faBadgeCheck} />
                           {trans('?Sélectionner')}
                        </li>
                     </>
                  ) : (
                     <li id={menu_items.doSee}>
                        <FontAwesomeIcon icon={faEye} />
                        {trans('?Voir')}
                     </li>
                  )
               })()}
               <li id={menu_items.sendPdf}>
                  <FontAwesomeIcon icon={faFilePdf} />
                  {trans('?Envoyer en PDF à...')}
               </li>
               {/* Dupliquer un KOT = créer un nouveau quota → réservé admin/N1 (canWriteKOT), comme la création. */}
               {canWriteKOT(selectedOrder, roleForCustomer) && <li id={menu_items.doClone}>
                  <FontAwesomeIcon icon={faClone} />
                  {trans('?Dupliquer')}
               </li>}
               {default_customer && selectedOrder && canWriteKOT(selectedOrder, roleForCustomer) && selectedOrder.customer_id !== default_customer.id && <li id={menu_items.doCloneToDefaultCustomer}>
                  <FontAwesomeIcon icon={faClone} />
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <span>
                        {trans('?Dupliquer')} {lowtrans('?Vers')}
                     </span>
                     <span>
                        {default_customer.name}
                     </span>
                  </div>
               </li>}
               {!selectedOrder?.readonly && canWriteKOT(selectedOrder, roleForCustomer) && <li id={menu_items.doDelete}>
                  <FontAwesomeIcon icon={faTrashCan} />
                  {trans('?Supprimer')}
               </li>}
               {/* Synchroniser (cmd classique) ou Soumettre (Retail user-client) — masqué pour KOT/KTM et pour managers Retail (N1/N2/admin) */}
               {!selectedOrder.readonly && !isKOTOrder(selectedOrder) && !isKTMOrder(selectedOrder) && !roleForCustomer.effectiveRole && (
                  isRetailOrder(selectedOrder)
                     ? retailRole === 'client'
                     : true
               ) && <li id={menu_items.doSync} disabled={(selectedOrder?.status !== order_status.new) || !canSyncOrder(selectedOrder)}>
                  <FontAwesomeIcon icon={isRetailOrder(selectedOrder) ? faArrowRight : faCloudArrowUp} />
                  {trans(isRetailOrder(selectedOrder) ? '?Soumettre' : '?Synchroniser')}
               </li>}
               {/* ───── Bloc workflow Retail manager : Soumission / Validation finale puis RETOUR AU CLIENT
                   juste en dessous. Séparateur au-dessus. (Pas de Sauvegarde/Restaurer dans ce menu contextuel.) */}
               {isRetailOrder(selectedOrder) && roleForCustomer.effectiveRole && (selectedOrder?.status === order_status.new || selectedOrder?.status === order_status.new_mgr || selectedOrder?.status === order_status.wait_n2 || selectedOrder?.status === order_status.wait_n1) && <hr style={{ border: 'none', borderTop: '1px solid #ddd', margin: '6px 0' }} />}
               {/* Soumettre (N2) — gâté par la complétude (contremarque + adresse) */}
               {isRetailOrder(selectedOrder) && roleForCustomer.isN2 && (selectedOrder?.status === order_status.new || selectedOrder?.status === order_status.new_mgr || selectedOrder?.status === order_status.wait_n2) && <li id={menu_items.doValidateN2} disabled={!isOrderComplete(selectedOrder)}>
                  <FontAwesomeIcon icon={faArrowRight} />
                  {trans('?Soumettre')}
               </li>}
               {/* Validation finale (admin/N1) — gâté par la complétude */}
               {isRetailOrder(selectedOrder) && (roleForCustomer.isAdmin || roleForCustomer.isN1) && (selectedOrder?.status === order_status.new || selectedOrder?.status === order_status.new_mgr || selectedOrder?.status === order_status.wait_n2 || selectedOrder?.status === order_status.wait_n1) && <li id={menu_items.doValidateN1} disabled={!isOrderComplete(selectedOrder)}>
                  <FontAwesomeIcon icon={faLock} />
                  {trans('?Validation finale')}
               </li>}
               {/* Retour au client — new_mgr → new via send-to-client. Libellé « Envoyer au client », icône identique à wait_n*. */}
               {isRetailOrder(selectedOrder) && roleForCustomer.effectiveRole && selectedOrder?.status === order_status.new_mgr && <li id={menu_items.doSendToClient}>
                  <FontAwesomeIcon icon={faLockOpen} />
                  {trans('?Envoyer au client')}
               </li>}
               {/* Retour au client — wait_n* : Renvoyer au client */}
               {isRetailOrder(selectedOrder) && roleForCustomer.effectiveRole && (selectedOrder?.status === order_status.wait_n2 || selectedOrder?.status === order_status.wait_n1) && <li id={menu_items.doUnlock}>
                  <FontAwesomeIcon icon={faLockOpen} />
                  {trans('?Renvoyer au client')}
               </li>}
            </DropdownMenu>
         )
      }
   }, [canSyncOrder, isOrderComplete, canWriteKOT, curOrder, default_customer, isKOTOrder, isKTMOrder, isRetailOrder, lowtrans, onSelectMenuOrder, order_status, retailRole, roleForCustomer, selectedOrder, showDropdownMenuOnOrderId, trans])


   const closeAllDropDowns = useCallback(() => {
      let ret = false

      if (showDropdownMenuGlobal) {
         setShowDropdownMenuGlobal(false)
         ret = true
      }
      if (showDropdownMenuOnAddressNum) {
         setShowDropdownMenuOnAddressNum(null)
         ret = true
      }
      if (showDropdownMenuOnContactNum) {
         setShowDropdownMenuOnContactNum(null)
         ret = true
      }
      if (showDropdownMenuOnOrderId) {
         setShowDropdownMenuOnOrderId(null)
         ret = true
      }
      if (showCreateMenu) {
         setShowCreateMenu(false)
         ret = true
      }
      return ret
   }, [showDropdownMenuGlobal, showDropdownMenuOnAddressNum, showDropdownMenuOnContactNum, showDropdownMenuOnOrderId, showCreateMenu])

   const onShowMenuContact = useCallback(
      (evt, num) => {
         evt.stopPropagation()
         closeAllDropDowns()
         if (showDropdownMenuOnContactNum === num) {
            setShowDropdownMenuOnContactNum(null)
         } else {
            setShowDropdownMenuOnContactNum(num)
         }
      },
      [closeAllDropDowns, showDropdownMenuOnContactNum]
   )

   const onShowMenuAddress = useCallback(
      (evt, num) => {
         evt.stopPropagation()
         closeAllDropDowns()
         if (showDropdownMenuOnAddressNum === num) {
            setShowDropdownMenuOnAddressNum(null)
         } else {
            setShowDropdownMenuOnAddressNum(num)
         }
      },
      [closeAllDropDowns, showDropdownMenuOnAddressNum]
   )

   function onCancelPickMailAddress() {
      setIsMailAddressPickerVisible(false)
   }

   const onValidatePickMailAddress = useCallback(async (arr_emails, message) => {
      console.log(arr_emails)
      setIsMailAddressPickerVisible(false)

      const order = await getOrderById(lastPickedOrderId)
      // Type repris de l'ordre : ECR/ECF utilisent le template _retail (col Disc., total remisé) côté genpdf
      awPushPDF(order?.type ?? 'CDE', order, arr_emails, message)
   }, [awPushPDF, getOrderById, lastPickedOrderId])

   const buildPhones = useCallback((prefix, phone1, phone2, country) => {
      const arr = [phone1, phone2].reduce((prev, phone, idx) => {
         if (!phone) {
            return [...prev]
         } else {
            let num
            if (formatPhone) {
               // https://www.npmjs.com/package/libphonenumber-js
               num = parsePhoneNumber(phone?.replaceAll(' ', ''), country)?.formatInternational()
            } else {
               num = phone
            }
            if (num === undefined) {   // Si country inconnue par exemple, ou autre pb de formatage
               num = phone
            }
            if (num) {
               return [...prev, <div key={`${prefix}_phone_${idx}`}><FontAwesomeIcon icon={faPhone} />{num}</div>]
            } else {
               return [...prev]
            }
         }
      }, [])
      return arr
   }, [formatPhone])

   const buildContactsLines = useCallback((customer) => {
      const contacts = getContactsFromCustomerAsSortedArray(customer)

      if (contacts) {
         // console.log('+++ADDR', contacts);
         return contacts.map((a_contact, idx) => {
            return (
               <tr key={`contacts_line_${idx}`}>
                  <td className={styles.cont_type}>
                     {a_contact.type}
                  </td>
                  <td className={styles.cont_name}>
                     {a_contact.name}
                  </td>
                  <td className={styles.cont_phone_mail}>
                     {buildPhones('contacts', a_contact.phone1, a_contact.phone2, a_contact.country)}
                     {a_contact.email && <div><FontAwesomeIcon icon={faEnvelopeSolid} />{a_contact.email}</div>}
                  </td>
                  <td className={styles.cont_actions}>
                     <span onClick={(evt) => onShowMenuContact(evt, idx)}>
                        {/* <FontAwesomeIcon icon={faGear} /> */}
                        {trans('?Détail', true)}
                        <FontAwesomeIcon icon={faAngleRight} />
                        {showDropdownMenuOnContactNum === idx ? dropdownMenuContact : ''}
                     </span>
                  </td>
               </tr>
            )
         })
      } else {
         return null
      }
   }, [buildPhones, dropdownMenuContact, getContactsFromCustomerAsSortedArray, onShowMenuContact, showDropdownMenuOnContactNum, trans])

   const onOrderLineClick = useCallback(
      (evt, num) => {
         // console.log('doNothing')
         evt.stopPropagation()
         closeAllDropDowns()
         if (showDropdownMenuOnOrderId !== null) {
            prepShowDropDown(null)
         } else {
            updateRecentOrders(num)
            navigate(`/order-detail?id=${num}`, { replace: false })
         }
      },
      [closeAllDropDowns, navigate, prepShowDropDown, showDropdownMenuOnOrderId, updateRecentOrders]
   )

   const onChangeChoice = useCallback((id, state) => {
      // console.log(
      //    `Item ${id}${state === CheckboxStates.Checked ? 'Checked' : 'Unchecked'
      //    }`
      // )
      setUnsyncLinesChecked(cur => {
         if (state === CheckboxStates.Checked) {
            return new Set([...cur, id])
         } else {
            return new Set([...cur].filter(an_id => an_id !== id))
         }
      })
   }, [])


   const onOrderShowMenu = useCallback(
      (evt, id) => {
         evt.stopPropagation()
         closeAllDropDowns()
         if (showDropdownMenuOnOrderId === id) {
            prepShowDropDown(null)
         } else {
            prepShowDropDown(id)
         }
      },
      [closeAllDropDowns, prepShowDropDown, showDropdownMenuOnOrderId]
   )

   const onSelectGlobal = useCallback((id) => {
      setShowDropdownMenuGlobal(false)
      if (id === global_menu_items.doSync) {
         setIsConfirmSyncVisible(true)
      } else if (id === global_menu_items.doSubmit) {
         setIsConfirmSubmitVisible(true)
      }
   }, [])

   // Drapeaux dérivés : pour activer / désactiver "Soumettre" (ECR/ECF) vs "Synchroniser" (non-retail).
   const hasCheckedRetail = useMemo(() => {
      if (!live_unsync_orders) return false
      return live_unsync_orders.some(o => unsyncLinesChecked.has(o.id) && isRetailOrder(o))
   }, [live_unsync_orders, unsyncLinesChecked, isRetailOrder])
   // Nb de commandes retail cochées (singulier/pluriel de la confirmation de soumission) — utilitaire commun.
   const nbCheckedRetail = useMemo(
      () => countCheckedRetail(live_unsync_orders, unsyncLinesChecked),
      [countCheckedRetail, live_unsync_orders, unsyncLinesChecked],
   )
   const hasCheckedNonRetail = useMemo(() => {
      if (!live_unsync_orders) return false
      return live_unsync_orders.some(o => unsyncLinesChecked.has(o.id) && !isRetailOrder(o))
   }, [live_unsync_orders, unsyncLinesChecked, isRetailOrder])



   useEffect(() => {
      setDropdownMenuGlobal(
         <DropdownMenu noscrollbars right={-20} top={30} onSelect={onSelectGlobal}>
            <li id={global_menu_items.doSubmit} disabled={!hasCheckedRetail}>
               <FontAwesomeIcon icon={faArrowRight} />
               {trans('?Soumettre')}
            </li>
            <li id={global_menu_items.doSync} disabled={!hasCheckedNonRetail}>
               <FontAwesomeIcon icon={faCloudArrowUp} />
               {trans('?Synchroniser')}
            </li>
         </DropdownMenu>
      );
   }, [onSelectGlobal, trans, hasCheckedRetail, hasCheckedNonRetail])
   // console.log(selectedOrder);

   const buildOrderLines = useCallback((orders, with_sync) => {
      let checkboxes

      if (with_sync) {
         checkboxes = unsyncLinesChecked
      }
      // console.log('+++ORDERS', orders);
      if (orders) {
         return orders?.map((an_order) => {
            // const a_customer = getCustomerById(an_order.customer_id)
            // console.log(a_customer);
            // Tout est valorisé en CESSION (retail ECR/ECF comme commandes classiques) → devise cession.
            const devise = customer?.tarifs?.ces?.currency
            // La technique du foundOme dans les unsync n'était pas ok car si la commande a été créée sur un autre ordi ou qu'il y a eu purge, on ne la trouve plus.
            // const found_oMe = live_unsync_orders?.find(an_ome_order => an_ome_order.m3_number === an_order.id)
            // J'ai maintenant un champ qui provient de la BI
            const found_oMe = an_order?.ome_doc_id ? (glob_const.regex_ome_doc_id.test(an_order.ome_doc_id) ? an_order.ome_doc_id : null) : null
            return (
               <tr key={`line_${an_order.id}`} className={(an_order.id === curOrder) ? styles.selected : ''} onClick={(evt) => { onOrderLineClick(evt, an_order.id) }}>
                  {with_sync && checkboxes && <td className={styles.checkbox}>
                     <div>
                        <Checkbox small light checked={checkboxes.has(an_order.id) ? CheckboxStates.Checked : CheckboxStates.Unchecked} onChange={(state) => onChangeChoice(an_order.id, state)} />
                     </div>
                  </td>}
                  <td className={styles.order_type}>
                     <div>
                        {(an_order.type === type_order.commande) && <FontAwesomeIcon icon={faGem} />}
                        {(an_order.type === type_order.implant) && <FontAwesomeIcon icon={faShelves} />}
                        {(an_order.type === type_order.confie) && <FontAwesomeIcon icon={faHandHoldingBox} />}
                        {(an_order.type === type_order.triangulaire) && <FontAwesomeIcon icon={faRecycle} />}
                        {(an_order.type === type_order.devis) && <FontAwesomeIcon icon={faFilePen} />}
                        {isRetailOrder(an_order) && <FontAwesomeIcon icon={faBox} />}
                        {isKOTOrder(an_order) && <FontAwesomeIcon icon={faScaleBalanced} />}
                        {isKTMOrder(an_order) && <FontAwesomeIcon icon={faObjectGroup} />}
                        <span>{an_order.type}</span>
                     </div>
                  </td>
                  <td className={styles.num_order}>
                     <div>
                        <span>{an_order.id}</span>
                        {an_order.mark && <span><FontAwesomeIcon icon={faBookmark} />{an_order.mark}</span>}
                     </div>
                  </td>
                  {!with_sync && <td className={styles.num_ome}>
                     {found_oMe && <>
                        <span>{found_oMe}</span>
                        <div className={styles.green}>   {/* Envoyé vers M3 */}
                           <FontAwesomeIcon icon={faCloud} />
                        </div>
                     </>
                     }
                  </td>}
                  <td className={styles.order_date}>
                     <div>
                        <span>{an_order.date}</span>
                        {/* {!an_order.readonly && <span>{an_order.time}</span>} */}
                     </div>
                  </td>
                  <td className={styles.order_total_price}>{formatCESPrice(calcTotalForOrder(an_order), devise)}</td>
                  {with_sync && <td className={styles.signature}>
                     <div>
                        {an_order.signature &&
                           <FontAwesomeIcon icon={faSignature} />
                        }
                     </div>
                  </td>}
                  {with_sync &&
                     <td className={styles.order_sync}>
                        {(an_order.status !== order_status.new) && (an_order.status !== order_status.new_mgr) && (an_order.status !== order_status.deleted) && (an_order.status !== order_status.locked4sync) &&
                           <div className={styles.green}>
                              {/* User-client retail en attente de validation : loupe-user au lieu du nuage (cf. hideRetailWorkflow) */}
                              <FontAwesomeIcon icon={isUnderRetailReview(an_order) ? faUserMagnifyingGlass : faCloud} />
                              {/* lock_n* (transit batch) et wait_n* (validation pending) : on affiche N1/N2 dans les 2 cas */}
                              {!hideRetailWorkflow(an_order) && (an_order.status === order_status.wait_n1) && <span>N1</span>}
                              {!hideRetailWorkflow(an_order) && (an_order.status === order_status.wait_n2) && <span>N2</span>}
                              {/* Retail en route vers M3 (locked = workflow terminé, wait_m3 = file d'intégration) */}
                              {!hideRetailWorkflow(an_order) && isRetailOrder(an_order) && (an_order.status === order_status.locked || an_order.status === order_status.wait_m3) && <span>M3</span>}
                           </div>
                        }
                        {an_order.status === order_status.locked4sync &&
                           <div className={styles.orange}>
                              <FontAwesomeIcon icon={faCloudXmark} />
                           </div>
                        }
                        {an_order.status === order_status.deleted &&
                           <div className={styles.red}>
                              <FontAwesomeIcon icon={faTrashXmark} />
                           </div>
                        }
                     </td>
                  }
                  <td className={styles.order_actions}>
                     <span onClick={(evt) => onOrderShowMenu(evt, an_order.id)}>
                        {/* <FontAwesomeIcon icon={faGear} /> */}
                        {trans('?Détail', true)}
                        <FontAwesomeIcon icon={faAngleRight} />
                        {showDropdownMenuOnOrderId === an_order.id ? dropdownMenuOrders : ''}
                     </span>
                  </td>
               </tr>
            )
         })
      } else {
         return null
      }
   }, [calcTotalForOrder, curOrder, customer?.tarifs.ces.currency, dropdownMenuOrders, formatCESPrice, hideRetailWorkflow, isRetailOrder, isKOTOrder, isKTMOrder, isUnderRetailReview, onChangeChoice, onOrderLineClick, onOrderShowMenu, order_status, showDropdownMenuOnOrderId, trans, type_order.commande, type_order.confie, type_order.devis, type_order.implant, type_order.triangulaire, unsyncLinesChecked])

   const buildAddressesLines = useCallback((customer) => {
      const addresses = getAddressesFromCustomerAsSortedArray(customer)

      if (addresses) {
         return addresses.map((an_address, idx) => {
            let icon, text
            if (an_address.id === type_address.siege) {
               icon = faBuilding
               text = tag_address.siege[currentLang ?? 'fr']
            } else if (an_address.id.startsWith(type_address.ecrins)) {
               icon = faBox
               text = tag_address.ecrins[currentLang ?? 'fr']
            } else if (an_address.id.startsWith(type_address.pos)) {
               icon = faBagsShopping
               text = tag_address.pos[currentLang ?? 'fr']
            } else {
               icon = faStore
               text = tag_address.other[currentLang ?? 'fr']
            }
            return (
               <tr key={`addresses_line_${idx}`}>
                  <td className={styles.addr_type}>
                     <div>
                        <FontAwesomeIcon icon={icon} />
                        <span>{text}</span>
                     </div>
                  </td>
                  <td className={styles.addr_name}>
                     {an_address.name}
                  </td>
                  <td className={styles.addr_address}>
                     <div>
                        {buildAddress(an_address as any).map((line, idx) => <span key={idx}>{line}</span>)}
                     </div>
                  </td>
                  <td className={styles.addr_phone_mail}>
                     {buildPhones('addresses', an_address.phone1, an_address.phone2, an_address.country)}
                  </td>
                  <td className={styles.addr_actions}>
                     <span onClick={(evt) => onShowMenuAddress(evt, idx)}>
                        {/* <FontAwesomeIcon icon={faGear} /> */}
                        {trans('?Détail', true)}
                        <FontAwesomeIcon icon={faAngleRight} />
                        {showDropdownMenuOnAddressNum === idx ? dropdownMenuAddress : ''}
                     </span>
                  </td>
               </tr>
            )
         })
      } else {
         return null
      }
   }, [getAddressesFromCustomerAsSortedArray, type_address.siege, type_address.ecrins, type_address.pos, buildAddress, buildPhones, trans, showDropdownMenuOnAddressNum, dropdownMenuAddress, tag_address.siege, tag_address.ecrins, tag_address.pos, tag_address.other, currentLang, onShowMenuAddress])

   useEffect(() => {
      setContactsLines(buildContactsLines(customer))
   }, [buildContactsLines, customer])

   // console.log('+++Contacts', contactsLines)

   useEffect(() => {
      setAddressesLines(buildAddressesLines(customer))
   }, [buildAddressesLines, customer])

   const sortOrders = (a, b) => {
      let comp = 0
      if ((typeof a.date === 'string') && (typeof b.date === 'string')) {
         comp = b.date.localeCompare(a.date)
      }
      if (comp === 0) {
         comp = b.id.localeCompare(a.id)
      }
      return comp
   }

   async function onConfirmSyncOK() {
      setIsConfirmSyncVisible(false)
      // Synchroniser ne s'applique PAS aux ECR/ECF (qui passent par "Soumettre").
      for (const an_order of live_unsync_orders) {
         if (unsyncLinesChecked.has(an_order.id) && !isRetailOrder(an_order) && canSyncOrder(an_order)) {
            await updateOrder(an_order.id, {
               status: order_status.locked4sync,   // On va essayer de la pousser sur AppWrite (c'est updateOrder qui s'en charge, elle va ensuite passer en locked)
               readonly: true,
            })
         }
      }
   }

   function onConfirmSyncCancel() {
      setIsConfirmSyncVisible(false)
   }

   async function onConfirmSubmitOK() {
      setIsConfirmSubmitVisible(false)
      // Soumettre s'applique aux ECR/ECF cochées (webhook submit → wait_n2/wait_n1/error décidé serveur-side).
      for (const an_order of live_unsync_orders) {
         if (unsyncLinesChecked.has(an_order.id) && isRetailOrder(an_order) && canSyncOrder(an_order)) {
            await submitRetailOrder(an_order)
         }
      }
   }

   function onConfirmSubmitCancel() {
      setIsConfirmSubmitVisible(false)
   }

   /*******************
    * SYNC
    *******************/

   useEffect(() => {
      setLinesSyncOrders(buildOrderLines(filteredSyncOrders, false))
   }, [buildOrderLines, filteredSyncOrders])

   useEffect(() => {
      // if (live_sync_orders && (curTab === tab_names.sync)) {
      if (live_sync_orders) {
         console.log('LIVE SYNC', live_sync_orders);
         const str = searchText?.trim().toLowerCase()
         let arr = live_sync_orders
         if (str && str.length) {
            if (searchModeInCustomer === search_type.order) {
               arr = arr?.filter((an_order) => {
                  return String(an_order.id).toLowerCase().includes(str) || an_order.mark?.toLowerCase().includes(str)
               })
            } else if (searchModeInCustomer === search_type.sku) {
               arr = arr?.filter((an_order) => {
                  const found = (an_order.lines.find((a_line) => a_line.sku.toLowerCase().includes(str)) !== undefined)
                  return found
               })
            }
         } else if (!filterCDE && !filterCDI && !filterCON && !filterTRI && !filterRET) {
            if (filterOME) {
               arr = live_sync_orders?.filter(an_order => glob_const.regex_ome_doc_id.test(an_order.ome_doc_id))
            } else {
               arr = live_sync_orders
            }
         } else {
            arr = live_sync_orders?.filter((an_order) => {
               if (filterOME) {
                  // if (filterOME && live_unsync_orders) {
                  // const found_oMe = live_unsync_orders.find(an_ome_order => an_ome_order.m3_number === an_order.id)

                  // if (found_oMe) {
                  //    return true
                  // }
                  if (!glob_const.regex_ome_doc_id.test(an_order.ome_doc_id)) {
                     return false
                  }
               }
               if (filterCDE && an_order.type === type_order.commande) {
                  return true
               }
               if (filterCDI && an_order.type === type_order.implant) {
                  return true
               }
               if (filterTRI && an_order.type === type_order.triangulaire) {
                  return true
               }
               if (filterCON && an_order.type === type_order.confie) {
                  return true
               }
               if (filterRET && isRetailOrder(an_order)) {
                  return true
               }
               return false
            })
         }

         const nbPagesMax = Math.ceil(arr.length / listPageLength)
         const curPage = Math.max(1, Math.min(nbPagesMax, curPageSyncOrders))
         const start = (curPage - 1) * listPageLength
         setFilteredSyncOrders(arr.sort(sortOrders).slice(start, start + listPageLength))
         setNbPagesSyncOrders(nbPagesMax)
         setCurPageSyncOrders(curPage)
      }
   }, [curPageSyncOrders, curTab, filterCDE, filterCDI, filterCON, filterTRI, filterOME, filterRET, isRetailOrder, getCustomerById, listPageLength, live_sync_orders, searchModeInCustomer, searchText, type_order])

   const onFirstPageChangeSyncOrders = useCallback((val) => {
      console.log('onFirstPageChangeSyncOrders', val)
      setFirstPageSyncOrders(val)
   }, [])

   const onPageChangeSyncOrders = useCallback((val) => {
      console.log('onPageChangeSyncOrders', val)
      setCurPageSyncOrders(val)
   }, [])

   useEffect(() => {
      setPagesButtonsSyncOrders(
         <PagesButtons from={firstPageSyncOrders} max={nbPagesSyncOrders} selected={curPageSyncOrders} onFirstPageChange={onFirstPageChangeSyncOrders} onPageChange={onPageChangeSyncOrders}></PagesButtons>
      )
   }, [curPageSyncOrders, firstPageSyncOrders, nbPagesSyncOrders, onFirstPageChangeSyncOrders, onPageChangeSyncOrders])

   /*******************
    * UNSYNC
    *******************/

   useEffect(() => {
      setLinesUnsyncOrders(buildOrderLines(filteredUnsyncOrders, true))
   }, [buildOrderLines, filteredUnsyncOrders])

   useEffect(() => {
      setLinesQuotaOrders(buildOrderLines(filteredQuotaOrders, true))
   }, [buildOrderLines, filteredQuotaOrders])

   useEffect(() => {
      // if (live_unsync_orders && (curTab === tab_names.unsync)) {
      if (live_unsync_orders) {
         console.log('LIVE UNSYNC', live_unsync_orders);
         const str = searchText?.trim().toLowerCase()
         let arr = live_unsync_orders
         if (str && str.length) {
            if (searchModeInCustomer === search_type.order) {
               arr = arr?.filter((an_order) => {
                  return String(an_order.id).toLowerCase().includes(str) || an_order.mark?.toLowerCase().includes(str)
               })
            } else if (searchModeInCustomer === search_type.sku) {
               arr = arr?.filter((an_order) => {
                  const found = (an_order.lines.find((a_line) => a_line.sku.toLowerCase().includes(str)) !== undefined)
                  return found
               })
            }

         } else if (!filterCDE && !filterCDI && !filterCON && !filterTRI && !filterDEV && !filterRET) {
            arr = live_unsync_orders
         } else {
            arr = live_unsync_orders?.filter((an_order) => {
               if (filterCDE && an_order.type === type_order.commande) {
                  return true
               }
               if (filterCDI && an_order.type === type_order.implant) {
                  return true
               }
               if (filterTRI && an_order.type === type_order.triangulaire) {
                  return true
               }
               if (filterCON && an_order.type === type_order.confie) {
                  return true
               }
               if (filterDEV && an_order.type === type_order.devis) {
                  return true
               }
               if (filterRET && isRetailOrder(an_order)) {
                  return true
               }
               if (isProspect && an_order.type === type_order.devis) {
                  return true
               }
               return false
            })
         }
         // Exclure KOT/KTM de l'onglet "En cours oMe" — ils ont leur propre onglet "Quotas"
         const arrUnsync = arr?.filter(an_order => !isKOTOrder(an_order) && !isKTMOrder(an_order))
         const nbPagesMax = Math.ceil(arrUnsync.length / listPageLength)
         const curPage = Math.max(1, Math.min(nbPagesMax, curPageUnsyncOrders))
         const start = (curPage - 1) * listPageLength
         setFilteredUnsyncOrders(arrUnsync.sort(sortOrders).slice(start, start + listPageLength))
         setNbPagesUnsyncOrders(nbPagesMax)
         setCurPageUnsyncOrders(curPage)

         // Onglet "Quotas" : KOT + KTM, réservés admin/N1 de ce customer. Le N2 en est exclu
         // (accès document interdit ; seul le picker exploite son quota en local).
         const arrQuotas = (arr ?? []).filter(an_order => {
            if (!(roleForCustomer.isAdmin || roleForCustomer.isN1)) return false
            return an_order.type === type_order.retail_quota || an_order.type === type_order.ktm_quota
         })
         const nbPagesMaxQuotas = Math.max(1, Math.ceil(arrQuotas.length / listPageLength))
         const curPageQuotas = Math.max(1, Math.min(nbPagesMaxQuotas, curPageQuotaOrders))
         const startQuotas = (curPageQuotas - 1) * listPageLength
         setFilteredQuotaOrders(arrQuotas.sort(sortOrders).slice(startQuotas, startQuotas + listPageLength))
         setNbPagesQuotaOrders(nbPagesMaxQuotas)
         setCurPageQuotaOrders(curPageQuotas)
      }


   }, [curPageUnsyncOrders, curPageQuotaOrders, curTab, filterCDE, filterCDI, filterCON, filterTRI, filterDEV, filterRET, isRetailOrder, isKOTOrder, isKTMOrder, isProspect, listPageLength, live_sync_orders, live_unsync_orders, roleForCustomer, searchModeInCustomer, searchText, type_order])

   const onFirstPageChangeUnsyncOrders = useCallback((val) => {
      console.log('onFirstPageChangeUnsyncOrders', val)
      setFirstPageUnsyncOrders(val)
   }, [])

   const onPageChangeUnsyncOrders = useCallback((val) => {
      console.log('onPageChangeUnsyncOrders', val)
      setCurPageUnsyncOrders(val)
   }, [])

   useEffect(() => {
      setPagesButtonsUnsyncOrders(
         <PagesButtons from={firstPageUnsyncOrders} max={nbPagesUnsyncOrders} selected={curPageUnsyncOrders} onFirstPageChange={onFirstPageChangeUnsyncOrders} onPageChange={onPageChangeUnsyncOrders}></PagesButtons>
      )
   }, [curPageUnsyncOrders, firstPageUnsyncOrders, nbPagesUnsyncOrders, onFirstPageChangeUnsyncOrders, onPageChangeUnsyncOrders])

   const onFirstPageChangeQuotaOrders = useCallback((val) => {
      setFirstPageQuotaOrders(val)
   }, [])

   const onPageChangeQuotaOrders = useCallback((val) => {
      setCurPageQuotaOrders(val)
   }, [])

   useEffect(() => {
      setPagesButtonsQuotaOrders(
         <PagesButtons from={firstPageQuotaOrders} max={nbPagesQuotaOrders} selected={curPageQuotaOrders} onFirstPageChange={onFirstPageChangeQuotaOrders} onPageChange={onPageChangeQuotaOrders}></PagesButtons>
      )
   }, [curPageQuotaOrders, firstPageQuotaOrders, nbPagesQuotaOrders, onFirstPageChangeQuotaOrders, onPageChangeQuotaOrders])

   useEffect(() => {
      if (live_unsync_orders) {
         setUnsyncLinesAllChecked(live_unsync_orders.length === unsyncLinesChecked.size)
         setUnsyncLinesNoneChecked(unsyncLinesChecked.size === 0)
      } else {
         setUnsyncLinesAllChecked(false)
         setUnsyncLinesNoneChecked(true)
      }
      // if (allSyncOrders) {
      //    setSyncLinesAllChecked(allSyncOrders.length === syncLinesChecked.size)
      //    setSyncLinesNoneChecked(syncLinesChecked.size === 0)
      // } else {
      //    setSyncLinesAllChecked(false)
      //    setSyncLinesNoneChecked(true)
      // }
   }, [live_unsync_orders, unsyncLinesChecked.size])

   const onSelAllChange = useCallback((state) => {
      closeAllDropDowns()
      // console.log('onSelAllChange', state)``
      if (live_unsync_orders && state) {
         setUnsyncLinesChecked(new Set(live_unsync_orders.map((an_order) => an_order.id)))
      } else {
         setUnsyncLinesChecked(new Set())
      }
   }, [closeAllDropDowns, live_unsync_orders])

   /*******************
    * FIN UNSYNC & SYNC
    *******************/

   function switchTab(tab) {
      setCurTab(tab)
   }

   function toogleShowDropdownMenuGlobal(evt) {
      evt.stopPropagation();
      closeAllDropDowns();
      setShowDropdownMenuGlobal(!showDropdownMenuGlobal);
   }

   function onGlobalClick(evt) {
      evt.stopPropagation()
      // prepShowDropDown(null)
      closeAllDropDowns()
   }

   function toggleItemsPerPageShowList() {
      setIsItemsPerPageOpen(!isItemsPerPageOpen)
   }

   function onItemsPerPageSelect(id) {
      // console.log('>>>>>>', id)
      setListPageLength(id)
      setIsItemsPerPageOpen(false)
   }

   function makeActive() {
      setCustomerIdAsCurrent(customer.id)
   }

   function leaveCustomer() {
      setCurCustomer(null)
      setCurOrder(null)
   }

   const doCreateOrder = useCallback(async () => {
      const new_order = makeTemplateOrder(customer.id)
      const curid = await createOrder(new_order)
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [createOrder, customer, makeTemplateOrder, navigate])

   const doCreateRetail = useCallback(async () => {
      const orderType = getRetailOrderType(customer)
      if (!orderType) return
      const new_order = makeTemplateOrder(customer.id)
      new_order.type = orderType === 'ECR' ? type_order.retail_interne : type_order.retail_externe
      const curid = await createOrder(new_order)
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [createOrder, customer, getRetailOrderType, makeTemplateOrder, navigate, type_order.retail_externe, type_order.retail_interne])

   const doCreateTemplate = useCallback(async () => {
      const new_order = makeTemplateOrder(customer.id)
      const curid = await createOrder({ ...new_order, type: "DEV" })
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [createOrder, customer, makeTemplateOrder, navigate])

   const doCreateRetailQuota = useCallback(async () => {
      const new_order = makeTemplateOrder(customer.id)
      new_order.type = type_order.retail_quota as any
      new_order.mark = generateKOTMark()
      const curid = await createOrder(new_order)
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [createOrder, customer, generateKOTMark, makeTemplateOrder, navigate, type_order.retail_quota])

   const doCreateKTM = useCallback((clientType: KTMClientType) => {
      setKtmCreateInitialMark(generateKTMMark(clientType))
      setShowKtmCreateEditor(true)
   }, [generateKTMMark])

   const onValidateKtmCreate = useCallback(async (mark: string) => {
      setShowKtmCreateEditor(false)
      const clientType = extractClientTypeFromKTMMark(mark)
      if (!clientType) return
      const ktmCustomerId = `${glob_const.prefix_ktm}${clientType}`
      await addFakeLocalCustomer({
         number: ktmCustomerId,
         id: ktmCustomerId,
         name: `<QUOTAS ${KTM_CLIENT_TYPES[clientType]}>`,
         phones: [],
         email: [],
         tariffs: JSON.stringify({ ces: { tarif: null, currency: null }, ppu: { tarif: null, currency: null } }),
         depot: null,
         credit: null,
         factures_ouvertes: null,
         contacts: [],
         addresses: [],
         last_updated: moment().toISOString(),
      })
      setCurCustomer(ktmCustomerId)
      const new_order = makeTemplateOrder(ktmCustomerId)
      new_order.type = type_order.ktm_quota as any
      new_order.mark = mark
      const curid = await createOrder(new_order)
      navigate(`/order-detail?id=${curid}`, { replace: false })
   }, [addFakeLocalCustomer, createOrder, extractClientTypeFromKTMMark, KTM_CLIENT_TYPES, makeTemplateOrder, navigate, setCurCustomer, type_order.ktm_quota])

   const onKOTImportFileChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0]
      if (kotImportFileRef.current) kotImportFileRef.current.value = ''
      if (!file) return
      try {
         const result = await importKOTFile(file)
         if (result.lines.length === 0) {
            toast.error(trans("?Aucune ligne valide dans le fichier"), { position: 'top-right', autoClose: 3000, theme: 'colored' })
            return
         }
         const errors = validateKOTLines(result.lines, { skuExists: (sku) => !!getRetailModelById(sku) })
         if (errors.length > 0) {
            toast.error(trans("?Import : SKU manquant, inconnu ou quantité invalide") + '\n' + errors.map(e => e.message).join('\n'), { position: 'top-right', autoClose: 5000, theme: 'colored' })
            return
         }
         const new_order = makeTemplateOrder(customer.id)
         new_order.type = type_order.retail_quota as any
         new_order.mark = result.metadata?.period ? `QUOTAS_${result.metadata.period}` : generateKOTMark()
         new_order.lines = result.lines.map(l => ({ sku: l.sku, qty: l.qty }))
         const curid = await createOrder(new_order)
         toast.success(trans("?Quota créé et lignes importées"), { position: 'top-right', autoClose: 2500, theme: 'colored' })
         navigate(`/order-detail?id=${curid}`, { replace: false })
      } catch {
         toast.error(trans("?Erreur lors de la lecture du fichier"), { position: 'top-right', autoClose: 3000, theme: 'colored' })
      }
   }, [createOrder, customer, generateKOTMark, getRetailModelById, makeTemplateOrder, navigate, trans, type_order.retail_quota])

   // Marks KTM existantes (tous customers) pour éviter les doublons à la création
   const live_all_unsync_orders = useLiveQuery(getUnsyncOrdersAsArray)
   const existingKtmMarks = useMemo(() => {
      return (live_all_unsync_orders ?? [])
         .filter(o => o.type === type_order.ktm_quota && o.mark)
         .map(o => o.mark!)
   }, [live_all_unsync_orders, type_order.ktm_quota])

   const onViewExistingKtm = useCallback((mark: string) => {
      const found = (live_all_unsync_orders ?? []).find(o => o.type === type_order.ktm_quota && o.mark === mark)
      if (!found?.id) return
      setShowKtmCreateEditor(false)
      navigate(`/order-detail?id=${found.id}`, { replace: false })
   }, [live_all_unsync_orders, navigate, type_order.ktm_quota])

   const onViewExistingQuotaClone = useCallback((mark: string) => {
      if (!quotaCloneSourceOrder) return
      const isKOT = isKOTOrder(quotaCloneSourceOrder)
      const targetType = isKOT ? type_order.retail_quota : type_order.ktm_quota
      const found = (live_unsync_orders ?? []).find(o => {
         if (o.mark !== mark || o.type !== targetType || o.id === quotaCloneSourceOrder.id) return false
         if (isKOT) return o.customer_id === quotaCloneSourceOrder.customer_id
         return true
      })
      if (!found?.id) return
      setShowQuotaCloneEditor(false)
      setQuotaCloneSourceOrder(null)
      navigate(`/order-detail?id=${found.id}`, { replace: false })
   }, [isKOTOrder, live_unsync_orders, navigate, quotaCloneSourceOrder, type_order.ktm_quota, type_order.retail_quota])

   function toggleCreateMenu(evt) {
      evt.stopPropagation()
      closeAllDropDowns()
      setShowCreateMenu(cur => !cur)
   }

   function onSelectCreate(id: string) {
      setShowCreateMenu(false)
      switch (id) {
         case create_menu_items.template: doCreateTemplate(); break;
         case create_menu_items.order: doCreateOrder(); break;
         case create_menu_items.retail: doCreateRetail(); break;
         case create_menu_items.kot: doCreateRetailQuota(); break;
         case create_menu_items.importKot: kotImportFileRef.current?.click(); break;
         case create_menu_items.ktmRet: doCreateKTM('RET'); break;
         case create_menu_items.ktmEre: doCreateKTM('ERE'); break;
         case create_menu_items.ktmInterco: doCreateKTM('INT'); break;
      }
   }

   return (
      <Fragment>
         <Menu page="customers" />
         <div className={styles.customer_detail} onClick={onGlobalClick}>
            {searchBar}
            <div className={styles.content}>
               <div className={styles.header_bg}>
                  <div className={styles.header}>
                     <h1>
                        <div className={styles.cust_name} style={(customer?.id?.startsWith(glob_const.prefix_ktm) || customer?.id?.startsWith(glob_const.prefix_prospect)) ? { fontStyle: 'italic' } : undefined}>{customer?.name}<span>{customer?.id}</span></div>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginLeft: 'auto' }}>
                           {(curCustomer === customer?.id) && !isSingleCustomer &&
                              <Button small secondary red onClick={leaveCustomer}>{trans("?Quitter le client")}</Button>
                           }
                           {(curCustomer !== customer?.id) &&
                              <Button small onClick={makeActive}>{trans("?Sélectionner")}</Button>
                           }
                           <div style={{ position: 'relative', zIndex: 1000 }}>
                              <Button small onClick={toggleCreateMenu}>
                                 {trans("?Créer...")}
                              </Button>
                              {showCreateMenu && (
                                 <DropdownMenu noscrollbars right={0} top={'50%'} onSelect={onSelectCreate}>
                                    {isProspect && (
                                       <li id={create_menu_items.template}>
                                          <FontAwesomeIcon icon={faSheetPlasticLight} />
                                          {trans("?Modèle")}
                                       </li>
                                    )}
                                    {!isProspect && canSeeJewelry && (
                                       <li id={create_menu_items.order}>
                                          <FontAwesomeIcon icon={faGemLight} />
                                          {trans("?Commande")}
                                       </li>
                                    )}
                                    {!isProspect && glob_const.retail_enabled
                                       && (retailRole === 'client' || roleForCustomer.effectiveRole !== null)
                                       && canCreateRetailOrder(customer) && (
                                       <li id={create_menu_items.retail}>
                                          <FontAwesomeIcon icon={faBoxLight} />
                                          {trans("?Commande Retail")}
                                          {getRetailOrderType(customer) === 'ECF' && (
                                             <FontAwesomeIcon icon={faCoins} style={{ marginLeft: '0.4rem', fontSize: '0.85em' }} />
                                          )}
                                       </li>
                                    )}
                                    {!isProspect && glob_const.retail_enabled && canCreateKOT(customer?.id) && (
                                       <li id={create_menu_items.kot}>
                                          <FontAwesomeIcon icon={faScaleBalancedLight} />
                                          {trans("?Quota Retail")}
                                       </li>
                                    )}
                                    {!isProspect && glob_const.retail_enabled && canCreateKOT(customer?.id) && (
                                       <li id={create_menu_items.importKot}>
                                          <FontAwesomeIcon icon={faFileImport} />
                                          {trans("?Importer quota")}
                                       </li>
                                    )}
                                    {/* Modèles de quotas masqués pour les retail-only (pas d'accès catalogue bijoux) */}
                                    {!isProspect && glob_const.retail_enabled && canCreateKTM() && canSeeJewelry && (
                                       <>
                                          <li id={create_menu_items.ktmRet}>
                                             <FontAwesomeIcon icon={faObjectGroupLight} />
                                             {trans("?Modèle Quotas")} ECR
                                          </li>
                                          <li id={create_menu_items.ktmEre}>
                                             <FontAwesomeIcon icon={faObjectGroupLight} />
                                             {trans("?Modèle Quotas")} ECF
                                          </li>
                                          <li id={create_menu_items.ktmInterco}>
                                             <FontAwesomeIcon icon={faObjectGroupLight} />
                                             {trans("?Modèle Quotas")} INT
                                          </li>
                                       </>
                                    )}
                                 </DropdownMenu>
                              )}
                           </div>
                        </div>
                     </h1>
                     <div className={styles.filters}>
                        {/* Onglet Informations masqué pour les retail-only (pas d'accès bijoux) */}
                        {canSeeJewelry && (
                        <span className={`${(curTab === tab_names.info) ? styles.selected : ''}`} onClick={() => switchTab(tab_names.info)}>
                           <FontAwesomeIcon icon={faCircleInfo} />
                           {trans('?Informations')}
                           <div className={styles.bot_border} />
                        </span>
                        )}
                        {/* <span className={`${(curTab === tab_names.stats) ? styles.selected : ''} ${styles.disabled}`} onClick={() => switchTab(tab_names.stats)}>
                           <FontAwesomeIcon icon={faChartPie} />
                           {trans('?Stats')}
                           <div className={styles.bot_border} />
                        </span> */}
                        <span className={(curTab === tab_names.contacts) ? styles.selected : ''} onClick={() => switchTab(tab_names.contacts)}>
                           <FontAwesomeIcon icon={faAddressBook} />
                           {trans('?Contact', true)}
                           <div className={styles.bot_border} />
                        </span>
                        <span className={(curTab === tab_names.addresses) ? styles.selected : ''} onClick={() => switchTab(tab_names.addresses)}>
                           <FontAwesomeIcon icon={faLocationDot} />
                           {trans('?Adresse', true)}
                           <div className={styles.bot_border} />
                        </span>
                        <span className={(curTab === tab_names.orders) ? styles.selected : ''} onClick={() => switchTab(tab_names.orders)}>
                           <FontAwesomeIcon icon={faBagShoppingSolid} />
                           {trans('?Traitée', true)} {filteredSyncOrders && filteredSyncOrders.length > 0 ? `(${filteredSyncOrders.length})` : ""}
                           <div className={styles.bot_border} />
                        </span>
                        <span className={(curTab === tab_names.unsync) ? styles.selected : ''} onClick={() => switchTab(tab_names.unsync)}>
                           <FontAwesomeIcon icon={faCloudSlash} />
                           {isProspect ? trans('?Template', true) : trans('?En cours oMe')} {filteredUnsyncOrders && filteredUnsyncOrders.length > 0 ? `(${filteredUnsyncOrders.length})` : ""}
                           <div className={styles.bot_border} />
                        </span>
                        {/* Onglet Quotas visible seulement pour admin / N1 de CE customer (le N2 n'accède pas aux documents KOT) */}
                        {(roleForCustomer.isAdmin || roleForCustomer.isN1) && (
                           <span className={(curTab === tab_names.quotas) ? styles.selected : ''} onClick={() => switchTab(tab_names.quotas)}>
                              <FontAwesomeIcon icon={faScaleBalanced} />
                              {trans('?Quotas')} {filteredQuotaOrders && filteredQuotaOrders.length > 0 ? `(${filteredQuotaOrders.length})` : ""}
                              <div className={styles.bot_border} />
                           </span>
                        )}
                     </div>
                  </div>
               </div>
               {/* {(curTab === tab_names.stats) &&
                  <div className={styles.detail_stats}>
                     <div className={styles.stat_buttons}>
                        <Button>Stat 1</Button>
                        <Button>Stat 2</Button>
                        <Button>Stat 3</Button>
                        <Button>Stat 4</Button>
                     </div>
                     <div>
                        <GraphPie num={1} year={2021} />
                        <GraphPie num={2} year={2022} />
                     </div>
                     <div>
                        <GraphLine />
                     </div>
                     <div>
                        <GraphPie num={3} year={2020} />
                        <GraphPie num={4} year={2019} />
                     </div>
                     <div>
                        <GraphLine />
                     </div>
                  </div>
               } */}
               {(curTab === tab_names.info) &&
                  <div className={styles.detail_info}>
                     <div className={styles.close_header}></div>{/* Pour fermer l'entête proprement */}
                     {stats}
                  </div>
               }
               {(curTab === tab_names.contacts) &&
                  <div className={styles.detail_contacts}>
                     <table>
                        <thead>
                           {/* "0504771-1": { "name": "WONG", "addr1": null, "addr2": null, "zip": null, "city": null, "country": null, "email": "Maggie.Wong@dfs.com", "phone1": null, "phone2": null }, */}
                           <tr>
                              <th>{trans('?Type')}</th>
                              <th>{trans('?Nom')}</th>
                              <th>{trans('?Téléphone')} / {trans('?Email')}</th>
                              <th></th>
                           </tr>
                        </thead>
                        <tbody>{contactsLines}</tbody>
                     </table>
                  </div>
               }
               {(curTab === tab_names.addresses) &&
                  <div className={styles.detail_addresses}>
                     <table>
                        <thead>
                           {/* "AT": { "name": "SAINT HONORE", "addr1": "?", "addr2": null, "zip": null, "city": null, "country": "France" }, */}
                           <tr>
                              <th>{trans('?Type')}</th>
                              <th>{trans('?Nom')}</th>
                              <th>{trans('?Adresse')}</th>
                              <th>{trans('?Téléphone')}</th>
                              <th></th>
                           </tr>
                        </thead>
                        <tbody>{addressesLines}</tbody>
                     </table>
                  </div>
               }
               {(curTab === tab_names.orders) &&
                  <div className={styles.detail_orders}>
                     <table>
                        <thead>
                           <tr>
                              <th>{trans('?Type')}</th>
                              <th>{trans('?N° Cde')}</th>
                              <th>oMe</th>
                              <th>{trans('?Date')}</th>
                              <th className={styles.order_total_price}>{trans('?Prix total')}</th>
                              <th></th>
                           </tr>
                        </thead>
                        <tbody>{linesSyncOrders}</tbody>
                     </table>
                  </div>
               }
               {(curTab === tab_names.unsync) &&
                  <div className={styles.detail_unsent_orders}>
                     <table>
                        <thead>
                           <tr>
                              <th>
                                 <div>
                                    <Checkbox small light three_states checked={unsyncLinesNoneChecked ? CheckboxStates.Unchecked : unsyncLinesAllChecked ? CheckboxStates.Checked : CheckboxStates.Undefined} onChange={() => onSelAllChange(!unsyncLinesAllChecked ? true : false)} />
                                 </div>
                              </th>
                              <th>{trans('?Type')}</th>
                              <th>{trans('?N° Cde')}</th>
                              <th>{trans('?Date')}</th>
                              <th className={styles.order_total_price}>{trans('?Prix total')}</th>
                              <th className={styles.signature}><FontAwesomeIcon icon={faSignature} /></th>
                              <th className={styles.order_sync}>{trans('?Sync')}</th>
                              <th className={styles.action}>
                                 <Button secondary onClick={toogleShowDropdownMenuGlobal} disabled={unsyncLinesNoneChecked}>
                                    {trans('?Action', true)}
                                    {showDropdownMenuGlobal && dropdownMenuGlobal}
                                 </Button>
                              </th>
                           </tr>
                        </thead>
                        <tbody>{linesUnsyncOrders}</tbody>
                     </table>
                  </div>
               }
               {(curTab === tab_names.quotas) &&
                  <div className={styles.detail_unsent_orders}>
                     <table>
                        <thead>
                           <tr>
                              <th></th>
                              <th>{trans('?Type')}</th>
                              <th>{trans('?N° Cde')}</th>
                              <th>{trans('?Date')}</th>
                              <th className={styles.order_total_price}>{trans('?Prix total')}</th>
                              <th className={styles.signature}></th>
                              <th className={styles.order_sync}></th>
                              <th className={styles.action}></th>
                           </tr>
                        </thead>
                        <tbody>{linesQuotaOrders}</tbody>
                     </table>
                  </div>
               }
               {((curTab === tab_names.orders) || (curTab === tab_names.unsync) || (curTab === tab_names.quotas)) &&
                  <div className={styles.footer_bg}>
                     <div className={styles.footer}>
                        <span>{trans('?Affichage de')}</span>
                        <DropdownField selectedValue={String(listPageLength)} showAbove height={36} onSelect={onItemsPerPageSelect} isOpen={isItemsPerPageOpen} onToggle={toggleItemsPerPageShowList} >
                           <Fragment key="10">10</Fragment>
                           <Fragment key="20">20</Fragment>
                           <Fragment key="50">50</Fragment>
                           <Fragment key="100">100</Fragment>
                           {/* <Fragment key="999999">{lowtrans("?Tous")}</Fragment> */}
                        </DropdownField>
                        <span>
                           {(listPageLength < 99999) ? trans('?par page') : ''}
                        </span>
                        <div>
                           {(listPageLength < 99999) && (curTab === tab_names.orders) && pagesButtonsSyncOrders}
                           {(listPageLength < 99999) && (curTab === tab_names.unsync) && pagesButtonsUnsyncOrders}
                           {(listPageLength < 99999) && (curTab === tab_names.quotas) && pagesButtonsQuotaOrders}
                           <span></span>
                           <Button>
                              <FontAwesomeIcon icon={faUpToLine} />
                           </Button>
                        </div>
                     </div>
                  </div>
               }
            </div>
         </div >
         {
            isConfirmVisible && (
               <Confirm yesno onOK={onConfirmOK} onCancel={onConfirmCancel} title={trans("?Suppression")} text={trans("?confirmer_suppression_bdc")} />
            )
         }
         {isMailAddressPickerVisible && (
            <MailAddressPicker customer={customer?.id} onCancel={onCancelPickMailAddress} onValidate={onValidatePickMailAddress} top={'20%'} minWidth={'30%'} maxWidth={'50%'} />
         )}
         {isConfirmSubmitVisible && (
            <Confirm yesno onOK={onConfirmSubmitOK} onCancel={onConfirmSubmitCancel} title={trans("?Soumettre")} text={trans("?confirmer_soumission_retail", nbCheckedRetail)} />
         )}
         {isConfirmSyncVisible && (
            <Confirm yesno onOK={onConfirmSyncOK} onCancel={onConfirmSyncCancel} title={trans("?Synchronisation")} text={trans("?confirmer_synchronisation_bdc")} />
         )}
         {finalValidationPopups}
         {returnToClientPopups}
         {submitPopups}
         <input type="file" accept=".csv,.xlsx" ref={kotImportFileRef} style={{ display: 'none' }} onChange={onKOTImportFileChange} />
         {showKtmCreateEditor && (
            <QuotaMarkEditor
               value={ktmCreateInitialMark}
               isKOT={false}
               existingMarks={existingKtmMarks}
               onCancel={() => setShowKtmCreateEditor(false)}
               onValidate={onValidateKtmCreate}
               onViewExisting={onViewExistingKtm}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
            />
         )}
         {showQuotaCloneEditor && quotaCloneSourceOrder && (
            <QuotaMarkEditor
               value={quotaCloneSourceOrder.mark ?? null}
               isKOT={isKOTOrder(quotaCloneSourceOrder)}
               existingMarks={existingQuotaCloneMarks}
               onCancel={() => {
                  setShowQuotaCloneEditor(false)
                  setQuotaCloneSourceOrder(null)
               }}
               onValidate={async (mark) => {
                  setShowQuotaCloneEditor(false)
                  await cloneOrder(quotaCloneSourceOrder.id, null, mark)
                  setQuotaCloneSourceOrder(null)
                  setCurTab(tab_names.unsync)
               }}
               onViewExisting={onViewExistingQuotaClone}
               top={'20%'}
               minWidth={'30%'}
               maxWidth={'50%'}
            />
         )}
         <ToastContainer />
      </Fragment >
   )
}

export default CustomerDetail
